module.exports = __webpack_public_path__ + "static/banner-mobile-68bb547e2c19c699a412d51bdbf59764.png";